// Join-screen banner presets. The host picks one in the admin dashboard;
// students see it above the join form.
export const BANNERS = [
  {
    id: "brand",
    label: "Udyog signature",
    url: "https://static.prod-images.emergentagent.com/jobs/b7f9df05-7c8f-424c-9101-a8f7aa4aef1e/images/bbd7f928d78cc070a6443eb57d03b1d50e00d30fa69fef2bda52da07048797e6.jpeg",
  },
  {
    id: "desk",
    label: "Study desk",
    url: "https://static.prod-images.emergentagent.com/jobs/b7f9df05-7c8f-424c-9101-a8f7aa4aef1e/images/2fd92c57d05a21e4bded96c7372dc4982abf1e1ed3ddb14775d535da0ae39918.jpeg",
  },
  {
    id: "gradient",
    label: "Emerald gradient",
    url: "https://images.unsplash.com/photo-1617957718645-7680362d6312?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  },
  {
    id: "waves",
    label: "Dark waves",
    url: "https://images.unsplash.com/photo-1710438399422-2fca27686bcd?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  },
  {
    id: "night",
    label: "Night study",
    url: "https://images.unsplash.com/photo-1690788210614-9052cffd8a14?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  },
];

// Accepts a preset id or a direct image URL.
export const bannerUrl = (value) => {
  if (!value) return BANNERS[0].url;
  if (/^https?:\/\//i.test(value)) return value;
  return (BANNERS.find((b) => b.id === value) || BANNERS[0]).url;
};
